import React from 'react';
import { Button } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { ArrowForward } from '@material-ui/icons';
import RaffleImageSection from 'components/Dashboard/WorldCup/RaffleImages/RaffleImageSection';
import Loading from 'components/Basic/Loading';
import useRaffleImages from './useRaffleImages';
import { IMAGE_SECTIONS } from './raffleImages.config';

const RaffleImages: React.FC = () => {
  const intl = useIntl();
  const { isLoading, isSaving, isSaveEnabled, getImageByType, handleFileChange, handleSave } = useRaffleImages();

  return (
    <div className="raffle_images_wrapper" id="raffle_images_wrapper">
      <div className="raffle_images_sections">
        {IMAGE_SECTIONS.map(section => (
          <RaffleImageSection
            key={section.type}
            type={section.type}
            title={intl.formatMessage({ id: section.titleId })}
            aspectRatio={section.aspectRatio}
            requiredWidth={section.requiredWidth}
            requiredHeight={section.requiredHeight}
            helperText={section.helperTextId ? intl.formatMessage({ id: section.helperTextId }) : undefined}
            currentImage={getImageByType(section.type)?.url}
            onChange={file => handleFileChange(section.type, file)}
          />
        ))}
      </div>
      <div className="raffle_images_footer">
        <Button className="save_btn" onClick={handleSave} disabled={!isSaveEnabled}>
          <FormattedMessage id="Save" />
          <ArrowForward />
        </Button>
      </div>
      {(isLoading || isSaving) && <Loading visible={isLoading || isSaving} />}
    </div>
  );
};

export default RaffleImages;
